import styled from '@emotion/styled/macro';
import { theme } from 'styles/theme';

export const UsersList = styled.div`
  overflow: hidden;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.neutral};
  border-radius: ${theme.radii.lg};
`;
